class Header extends HTMLElement {
  constructor() {
    super();
    const searchModal = this.querySelector('.site-header__search');
    const searchToggles = this.querySelectorAll('[data-search-toggle]');
    let searchIsActive = false;

    if (searchModal && searchToggles.length > 0 ) {
      var searchInput = searchModal.querySelector('.search-bar__input');
      // Toggle search modal
      searchToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          document.body.classList.toggle('search-is-active');
          searchIsActive = !searchIsActive;

          if (!searchIsActive || !searchInput) return;

          const handleInputFocus = () => {
            searchInput.focus();
            searchModal.removeEventListener('transitionend', handleInputFocus);
          }

          searchModal.addEventListener('transitionend', handleInputFocus);
        })
      });

      // Hide search modal when user clicks outside
      document.body.addEventListener('click', (event) => {
        if (!searchIsActive) return;

        const isSearchToggle = event.target.closest('[data-search-toggle]');
        const isSearchModal = event.target.closest('.site-header__search');

        if (isSearchToggle || isSearchModal) return;

        document.body.classList.remove('search-is-active');
        searchIsActive = false;
      })
    }

    const nav_drawer = document.querySelector('#NavDrawer')

  }

}
customElements.define('site-header', Header);
